export const DESCRIPTION_TEXT = "The page you are looking for doesn't exist";
export const GO_BACK_BTN_TEXT = "Go Back to Homepage";
export const CONTACT_US_BTN_TEXT = "Contact Us";
export const ABOUT_US_BTN_TEXT = "About Us / FAQ";

export const CONTACT_US_URL = "https://www.livingrewards.co.nz/contact-us/";